import React from 'react'
import dndItemTypes from '../../constants/dndItemTypes'
import DropTargetWrapperContainer from '../../containers/dnd/DropTargetWrapperContainer'
import Translation from '../Translation/cont/Translation'
import TranslationDate from '../Translation/cont/TranslationDate'


const CollectionDropzone = ({id, dateStart, dateEnd, week, items, addItemToCollection, selectionType}) => (
    <li className="periode-item-container">
        <div className='text-periode-date accordion-headline title-large-light'>
            <TranslationDate hasYear={true} string={dateStart}/>  - <TranslationDate hasYear={true} string={dateEnd}/> 
        </div>

        <div className='text-periode-week title-large-light'>
            <Translation id="movie_sort_cw">KW</Translation> {week}
        </div>

        <DropTargetWrapperContainer
            listID={id}
            items={items}
            selectionType={selectionType}
            pushItem={addItemToCollection}
            dndType={dndItemTypes.PROGRAM_ITEM_AD}
        > 
            <div className="periode-item-dropbox">
                <div className="periode-item-dropbox-inner"></div>
            </div>
        </DropTargetWrapperContainer>
    </li>
)


export default CollectionDropzone